// Hands a lead (or a new lead's number) from the Chats page to the Lead Tracker in a new tab.
// The details go through localStorage under a one-time key, and only that key is in the address,
// so a customer's number never ends up in the URL or the browser history.
const PREFIX = "io-lead-handoff:";
const MAX_AGE_MS = 5 * 60 * 1000;

const randomKey = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, "");
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
};

// Old hand-offs that were never picked up (the tab was closed first) are cleared on the way.
const clearStale = () => {
  try {
    const now = Date.now();
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const name = localStorage.key(i);
      if (!name?.startsWith(PREFIX)) continue;
      const item = JSON.parse(localStorage.getItem(name) || "{}");
      if (!item.at || now - item.at > MAX_AGE_MS) localStorage.removeItem(name);
    }
  } catch {
    // Storage blocked: nothing to clear.
  }
};

// action: "openLead" with { leadId, leadCode } or "newLead" with { customerNumber }.
export const openInLeadTracker = (path, action, details) => {
  clearStale();
  const key = randomKey();
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ action, ...details, at: Date.now() }));
  } catch {
    // Without storage the Lead Tracker still opens; the person finds the lead there.
  }
  window.open(`${path}?handoff=${encodeURIComponent(key)}`, "_blank", "noopener,noreferrer");
};

// Read once by the Lead Tracker when it opens; the key is removed from the address afterwards.
export const takeLeadHandoff = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const key = params.get("handoff");
    if (!key) return null;
    params.delete("handoff");
    const query = params.toString();
    window.history.replaceState(null, "", `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`);
    const raw = localStorage.getItem(PREFIX + key);
    localStorage.removeItem(PREFIX + key);
    if (!raw) return null;
    const item = JSON.parse(raw);
    if (!item.at || Date.now() - item.at > MAX_AGE_MS) return null;
    return item;
  } catch {
    return null;
  }
};
